import Vue from 'vue'
import App from './App.vue'
import router from './route/router'
import store from './store' // store
import config from './config'
import { handleTree } from './utils/ruoyi'
import { isIOS, isAndroid, isApp } from './utils/helper'

// 引入微信SDK
import WeixinSDK from 'weixin-js-sdk';
// import WeixinSDK from './utils/wxSdk'

// 引入UniApp微信插件
import uni from './utils/uni.webview.1.5.6'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 引入vant组件库
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

import { Toast } from 'vant'
Vue.use(Toast)

// 移动端适配
import './flexible'

// vant桌面端适配
import '@vant/touch-emulator'

const plusReady = (callback) => {
  if (window.plus) {
    callback();
  } else {
    document.addEventListener('plusready', callback);
  }
}

Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.prototype.$config = config
Vue.prototype.handleTree = handleTree
Vue.prototype.$isIOS = isIOS
Vue.prototype.$isAndroid = isAndroid
Vue.prototype.$isApp = isApp;
Vue.prototype.$uni = uni
Vue.prototype.$wx = WeixinSDK
Vue.prototype.plusReady = plusReady
Vue.prototype.$eventBus = new Vue()

/**
 * 添加移动端手指按压事件指令，类似PC端hover效果
 * 使用方法：
 * <template>
 *  <button v-touch-hover>按钮1</button>
 *  <div v-touch-hover class="item">列表项</div>
 * </template>

 * <style>
 * // 全局触摸反馈样式 //
 * .touch-hover-active {
 *   opacity: 0.8;
 *   transition: all 0.15s;
 * }

 * // 可针对不同元素单独调整 //
 * button.touch-hover-active {
 *  background: #eee;
 * }

 * .item.touch-hover-active {
 *  background: #f5f5f5;
 * }
 * </style>
 */

Vue.directive('touch-hover', {
  bind(el, binding) {
    // 触摸开始：添加样式类
    const handleStart = () => {
      el.classList.add('touch-hover-active')
    }
    // 触摸结束/中断：移除样式类
    const handleEnd = () => {
      el.classList.remove('touch-hover-active')
    }
    // 绑定事件
    el.addEventListener('touchstart', handleStart)
    el.addEventListener('touchend', handleEnd)
    el.addEventListener('touchcancel', handleEnd)
    // 解绑事件（防止内存泄漏）
    el._unbindTouchHover = () => {
      el.removeEventListener('touchstart', handleStart)
      el.removeEventListener('touchend', handleEnd)
      el.removeEventListener('touchcancel', handleEnd)
    }
  },
  unbind(el) {
    el._unbindTouchHover && el._unbindTouchHover()
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
